import styled from "@emotion/styled";

const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 160px);
`

export default PageContainer